import { generate } from "short-uuid";
const registry = new Map();
export const generateId = () => generate();
export const registerDialogCallbacks = (callbacks) => {
    const id = generateId();
    registry.set(id, callbacks);
    return id;
};
export const getDialogCallbacks = (id) => registry.get(id);
export const unregisterDialogCallbacks = (id) => {
    registry.delete(id);
};
export const clearDialogCallbacks = () => {
    registry.clear();
};
